<template>
  <div class="flex flex-col items-center justify-center py-16 gap-4">
    <span class="i-lucide-globe w-12 h-12 text-n-slate-10" />
    <div class="text-center">
      <h3 class="text-base font-semibold text-n-slate-12 m-0">
        {{ $t('KNOWLEDGE_BASE.WEBSITES.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11 mt-1 m-0 max-w-sm">
        {{ $t('KNOWLEDGE_BASE.WEBSITES.COMING_SOON') }}
      </p>
    </div>
    <span class="px-3 py-1 text-xs font-medium rounded-full bg-n-alpha-2 text-n-slate-11">
      {{ $t('KNOWLEDGE_BASE.WEBSITES.BADGE') }}
    </span>
  </div>
</template>
